import React, { createContext, useContext, useState } from "react";

export type PaginaTypes ={
  GTIN: string;
  DESCRICAO: string;
  TIPO_GTIN: string;
}


type SearchPaginationContextType = {
  currentUiPage: number; 
  setCurrentUiPage: (n: number) => void;

  rowsPerPage: number;
  setRowsPerPage: (n: number) => void;

  selectedDatasetPage: number | null;  
  setSelectedDatasetPage: (n: number | null) => void;

  selectedDatasetIndex: number | null;  
  setSelectedDatasetIndex: (n: number | null) => void;

  setSelectedFromRow: (page: number, absoluteIndex: number) => void;

  Datapagina: PaginaTypes[];
  setDatapagina: React.Dispatch<React.SetStateAction<PaginaTypes[]>>;

  stepMaganer: "list" | "table" | "none";
  setStepMaganer: React.Dispatch<React.SetStateAction<"list" | "table" | "none">>;

  exportGtins?: string[] | undefined;
  setExportGtins?: React.Dispatch<React.SetStateAction<string[] | undefined>>;

  selectRows?: string[];
  setSelectRows?: React.Dispatch<React.SetStateAction<string[]>>;

  dataAll?: string[]
  setDataAll?: React.Dispatch<React.SetStateAction<string[]>>;

};

const SearchPaginationContext = createContext<SearchPaginationContextType | null>(null);

export const SearchPaginationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentUiPage, setCurrentUiPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [Datapagina, setDatapagina] = useState<PaginaTypes[]>([]);
  const [exportGtins, setExportGtins] = useState<string[] | undefined>([]);
  const [stepMaganer, setStepMaganer] = useState<"list" | "table" | "none">("none");

  const [selectedDatasetPage, setSelectedDatasetPage] = useState<number | null>(null);
  const [selectedDatasetIndex, setSelectedDatasetIndex] = useState<number | null>(null);

  const [selectRows, setSelectRows] = useState<string[]>([]);
  const [dataAll, setDataAll] =useState<string[]>([]);

  const setSelectedFromRow = (page: number, absoluteIndex: number) => {
    setSelectedDatasetPage(page);
    setSelectedDatasetIndex(absoluteIndex);
  };

  return (
    <SearchPaginationContext.Provider
      value={{
        currentUiPage,
        exportGtins,
        selectRows,
        dataAll,
        setDataAll,
        setSelectRows,
        setExportGtins,
        setDatapagina,
        stepMaganer,
        setStepMaganer,
        Datapagina,
        setCurrentUiPage,
        rowsPerPage,
        setRowsPerPage,
        selectedDatasetPage,
        setSelectedDatasetPage,
        selectedDatasetIndex,
        setSelectedDatasetIndex,
        setSelectedFromRow,
      }}
    >
      {children}
    </SearchPaginationContext.Provider>
  );
};

export const useSearchPagination = () => {
  const ctx = useContext(SearchPaginationContext);
  if (!ctx) throw new Error("useSearchPagination must be used inside <SearchPaginationProvider>");
  return ctx;
};
